import axios from 'axios'
import router from '../router/index'
import { MessageBox, Message } from 'element-ui'
// import router from '../router'
// 引入路由是为了做重定向，比如没有登录过期定向到登录页面
// 创建axios实例
const url = process.env.NODE_ENV === 'development' ? 'http://192.168.0.221:8018' : 'http://aicontest.xinhuaskl.com/api'
const instance = axios.create({
	baseURL: url, // api的base_url(请求的基地址)
	timeout: 150000, // 请求超时时间
	headers: {
		'content-type': 'application/json;charset=UTF-8'
	}
})
axios.defaults.baseURL = url
// 拦截请求
instance.interceptors.request.use(
	(config) => {
		// config.url = process.env.NODE_ENV === 'development' ? config.url : `/${config.url}`
		//  可以在此处添加 token
		// str.substr(str.length - 2) == '/c'
		if (config.url.slice(config.url.length - 2) === '/c') {
			if (localStorage.getItem('token_c')) {
				config.headers.Authorization = localStorage.getItem('token_c')
			}
			// else if (config.url == '/auth/code/c') {
			// 	localStorage.removeItem('username_c')
			// 	localStorage.removeItem('phone_c')
			// 	localStorage.removeItem('email_c')
			// 	localStorage.removeItem('token_c')
			// 	router.push({ path: '/login_c' })
			// }
		} else {
			if (localStorage.getItem('token_b')) {
				config.headers.Authorization = localStorage.getItem('token_b')
			}
			// else {
			// 	localStorage.removeItem('username_b')
			// 	localStorage.removeItem('nickName_b')
			// 	localStorage.removeItem('token_b')
			// 	localStorage.removeItem('userType_b')
			// 	localStorage.removeItem('value')
			// 	localStorage.removeItem('index')
			// 	localStorage.removeItem('progressNow')
			// 	router.push({ path: '/login_b' })
			// }
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)
// 拦截响应
instance.interceptors.response.use(
	(res) => {
		// 可以在此处拦截接口错误
		return res
	},
	(error) => {
		if (error.response.status === 401) {
			if (error.response.config.url.indexOf('/c') != -1 || error.response.config.url.indexOf('/user/auth/loginbycode') != -1) {
				localStorage.removeItem('username_c')
				localStorage.removeItem('phone_c')
				localStorage.removeItem('email_c')
				localStorage.removeItem('token_c')
				router.push({ path: '/login_c' })
			} else {
				localStorage.removeItem('username_b')
				localStorage.removeItem('nickName_b')
				localStorage.removeItem('token_b')
				localStorage.removeItem('userType_b')
				localStorage.removeItem('value')
				localStorage.removeItem('index')
				localStorage.removeItem('progressNow')
				router.push({ path: '/login_b' })
			}
			Message({
				showClose: true,
				// message: error.response.data.message, //弹出失败原因
				message: '未检测到登录信息！', //弹出失败原因
				type: 'error'
			})
		} else if (error.response.status === 400) {
			Message({
				showClose: true,
				message: error.response.data.message, //弹出失败原因
				type: 'error'
			})
		}
		// Message({
		// 	showClose: true,
		// 	message: error.response.data.message, //弹出失败原因
		// 	type: 'error'
		// })
		// return Promise.reject(error)
	}
)
export default instance
